import {defineStore, storeToRefs} from "pinia";
import {computed, watch, ref} from "vue";
import {update} from "../api/profile";
import {setAuthState} from "../composables/auth";
import {useSubscriptionPlanStore} from "./subscription.store";

export const useOnboardingChecklist = defineStore("checklist", () => {
    const { setUser, getUser, isAuthenticated } = setAuthState()
    const subscriptionStore = useSubscriptionPlanStore()
    const { isSubscribe } = storeToRefs(subscriptionStore);
    
    const checklistLevels = ref(
        [
            {
                level: 0,
                title: "ResumAI",
                description: "",
                icon: '',
                skipped: false,
                nextLevel: "ResumAI",
                progress: 0,
                items: [],
                completed: false
            },
            {
                level: 1,
                title: "ResumAI",
                link: 'resumes',
                description: "Build your best resume yet!",
                icon: '<svg width="147" height="27" viewBox="0 0 147 27" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.0625 26.4939H2.3683C2.8597 23.4763 2.8597 21.5526 4.4851 19.1386C5.3545 17.8184 6.9421 16.6869 9.2101 16.0079L15.0313 26.4939H19.9453L13.5949 15.0272C16.6945 13.8202 18.6223 11.2176 18.6223 7.93598C18.6223 3.33422 14.8423 0.090362 9.4747 0.090362H0.0625V26.4939ZM4.4095 14.0465V4.12633H9.4747C12.3097 4.12633 14.3131 5.71054 14.3131 7.93598C14.3131 9.21843 13.6327 10.2746 12.5365 10.9535C10.6843 12.0851 7.6981 12.0851 4.4095 14.0465ZM39.5047 22.4579L36.3295 20.6851C35.1577 22.2693 33.3055 23.0614 30.9997 23.0237C28.2403 22.986 26.0479 21.2509 25.4431 18.4974H39.7693C40.4119 10.6518 36.0271 7.06843 30.7351 6.99299C25.1029 6.91756 21.2851 11.1044 21.2851 16.9509C21.2851 22.6842 25.2919 26.8333 30.9997 26.8711C34.8553 26.9088 37.7659 25.3246 39.5047 22.4579ZM25.5565 14.914C26.1991 12.3869 28.1269 10.7649 30.7351 10.7649C33.1543 10.7649 35.2711 12.3869 35.9893 14.914H25.5565ZM54.1207 11.8965L55.9351 9.10527C54.3853 7.74738 51.7015 6.91756 48.9421 6.99299C44.7463 7.10615 42.0625 9.29387 42.0625 12.4623C42.0625 16.1965 45.5401 17.8561 48.6019 18.3842C51.7015 18.9123 53.1001 19.6667 53.1001 20.9114C53.1001 22.7219 51.0967 23.2123 48.8287 23.0614C46.9387 22.9483 45.4267 22.043 44.4061 20.6851L41.1553 22.5711C42.4027 25.0228 45.2755 26.8711 49.3957 26.8711C54.1207 26.8711 57.2581 24.457 57.2581 21.0246C57.2581 17.2149 54.3853 15.6684 50.8321 15.0649C47.5057 14.4991 46.2961 13.8579 46.2961 12.5377C46.2961 11.7079 47.2033 10.7272 48.9421 10.614C50.9455 10.5009 52.4953 10.8404 54.1207 11.8965ZM78.1027 7.40791H73.9447L73.9825 17.7807C73.7935 21.0623 71.7523 23.0237 68.5771 23.0237C65.4397 23.0237 64.2679 19.893 64.2679 16.9132V7.40791H60.1099V16.536C60.1477 22.7597 61.9621 26.9088 68.1991 26.9088C70.7317 26.9088 72.6217 25.8904 74.0203 24.3816L74.3227 26.4562H78.1027V7.40791ZM82.2775 26.4562H86.4355V16.6869C86.4355 13.1035 88.8547 10.8404 91.5763 10.8404C94.6003 10.8404 95.4697 13.9711 95.4697 16.9509V26.4562H99.5143V17.3281C99.5143 16.8377 99.5143 16.3474 99.4765 15.857C99.7033 12.7263 102.312 10.8404 104.844 10.8404C107.641 10.8404 108.7 13.9711 108.7 16.9509V26.4562H112.858V17.3281C112.82 11.1044 111.043 6.99299 106.054 6.99299C102.916 6.99299 100.119 8.31317 98.3425 10.2746C97.3219 8.27545 95.5075 7.10615 92.2189 6.99299C89.7619 6.91756 87.8341 8.01142 86.4355 9.63334V7.40791H82.2775V26.4562ZM114.372 26.4562H119.059L121.857 18.9877C125.523 18.7237 128.207 19.1009 130.551 20.3833C134.52 22.5711 135.88 24.9474 136.977 26.5693H139.434L129.228 0.0526425H124.54L114.372 26.4562ZM123.558 14.5369L126.884 5.74826L130.815 16.1588C129.039 15.2158 127.111 14.4991 123.558 14.5369ZM141.216 0.0149231L141.594 11.4816L141.631 14.3105L141.48 26.4562H146.016V22.9105C146.016 17.064 145.903 10.4632 144.429 4.08861L143.673 0.0149231H141.216Z" fill="#073B5D"/></svg>',
                skipped: false,
                progress: 0,
                completed: false,
                nextLevel: 'CoverletterAI',
                items: [{
                    name: "watchResumeTutorial",
                    description: "Watch <a class='text-won-green hover:underline font-bold'>ResumAI Tutorial</a>",
                    info: 'Watch the full tutorial of how you can use ResumAI to make the perfect bullet points and resume to land interviews!',
                    link: 'https://www.youtube.com/watch?v=yYhbXzKgkgQ&t=13s',
                    showInfo: false,
                    showLink: true,
                    completed: false
                },
                    {
                        name: "uploadResume",
                        description: "<p>Upload resume to ResumAI (Optional)</p>",
                        info: ' If you already have an existing resume you’d like to use in our ResumAI template, simply upload your resume using this link!',
                        showInfo: false,
                        showLink: false,
                        checkSubscription: false,
                        completed: false,
                    },
                    {
                        name: "createFirstBulletPoint",
                        description: "<p>Create first resume bullets</p>",
                        info: 'In Resume Builder, go to your experience section(s) and select “Generate Points”. You can also use our Bullet Generator if you’d like to create bullets outside of our template.',
                        showInfo: false,
                        showLink: false,
                        checkSubscription: false,
                        completed: false
                    }, {
                        name: "get75ResumeScore",
                        description: "<p>Get an 75+ on Resume Score</p>",
                        info: ' In Resume Builder, Go to the right side where the Resume Score will be shown. View your score breakdown and add bullets, fix your formatting, gather more information, and implement skills to increase your score!',
                        showInfo: false,
                        showLink: false,
                        checkSubscription: false,
                        completed: false
                    }, {
                        name: "downloadResume",
                        description: "<p>Download resume</p>",
                        info: ' Once you’ve finished your resume, select the “Download” button at the top right of our Resume Builder. You can download in either PDF or Word format.',
                        showInfo: false,
                        showLink: false,
                        completed: false
                    }]
            },
            {
                level: 2,
                title: "CoverletterAI",
                description: "Create an outstanding Cover Letter!",
                icon: '<svg width="227" height="42" viewBox="0 0 227 42" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_4913_6930" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="227" height="42"><path d="M227 0H0V42H227V0Z" fill="white"/></mask><g mask="url(#mask0_4913_6930)"><path d="M24.8381 28.0737L22.5328 27.3737C19.1492 32.5684 12.7538 32.2368 8.47776 29.7316C4.27612 27.2632 1.45024 20.9263 4.7595 15.9158C8.32903 10.5 14.3898 11.2737 18.703 13.7421C19.9672 14.479 21.1199 15.5105 22.0122 16.7632L25.433 15.0684C24.5035 13.1158 22.979 11.4211 20.9339 10.2421C14.5385 6.52106 6.84173 8.03158 2.86318 14.479C-1.11536 20.9632 -0.111428 29.5105 6.2468 33.2684C12.6422 36.9526 20.3762 35.479 24.3176 28.9947C24.5035 28.7 24.6894 28.3684 24.8381 28.0737ZM36.2171 35.0368C41.7945 35.0368 45.7359 31.0211 45.7359 25.3474C45.7359 19.6368 41.7945 15.6211 36.2171 15.6211C30.6025 15.6211 26.6612 19.6368 26.6612 25.3474C26.6612 31.0211 30.6025 35.0368 36.2171 35.0368ZM30.7513 25.3474C30.7513 21.8474 33.0194 19.379 36.2171 19.379C39.4148 19.379 41.6458 21.8474 41.6458 25.3474C41.6458 28.8105 39.4148 31.279 36.2171 31.279C33.0194 31.279 30.7513 28.8105 30.7513 25.3474ZM52.7338 34.6316H57.1586L64.372 16.0263H59.8729L54.8904 29.9158L49.8708 16.0263H45.3717L52.7338 34.6316ZM83.2242 30.7263L80.1008 28.9947C78.9482 30.5421 77.1262 31.3158 74.8581 31.279C72.1437 31.2421 69.9871 29.5474 69.3922 26.8579H83.4844C84.1165 19.1947 79.8034 15.6947 74.5978 15.6211C69.0576 15.5474 65.3021 19.6368 65.3021 25.3474C65.3021 30.9474 69.2435 35 74.8581 35.0368C78.6507 35.0737 81.5138 33.5263 83.2242 30.7263ZM69.5038 23.3579C70.1359 20.8895 72.0322 19.3053 74.5978 19.3053C76.9775 19.3053 79.0597 20.8895 79.7662 23.3579H69.5038ZM85.2196 34.6316H89.3097V26.8947C89.3097 22.6211 91.3175 20.0053 93.5857 19.7474C95.6679 19.5263 96.9693 20.2263 97.4526 20.5947L99.4233 17.6474C98.345 16.6526 96.8949 15.7684 94.2178 15.8421C92.1355 15.879 90.4995 17.0947 89.3097 18.7526V16.0263H85.2196V34.6316ZM101.269 34.6316H118.447V30.6526H104.43C105.88 24.4263 105.991 17.979 105.991 12.2684V8.80527H101.529L101.678 20.6684L101.641 23.4316L101.269 34.6316ZM138.328 30.7263L135.205 28.9947C134.052 30.5421 132.23 31.3158 129.962 31.279C127.248 31.2421 125.091 29.5474 124.497 26.8579H138.589C139.221 19.1947 134.908 15.6947 129.702 15.6211C124.162 15.5474 120.406 19.6368 120.406 25.3474C120.406 30.9474 124.348 35 129.962 35.0368C133.755 35.0737 136.618 33.5263 138.328 30.7263ZM124.608 23.3579C125.24 20.8895 127.136 19.3053 129.702 19.3053C132.082 19.3053 134.164 20.8895 134.87 23.3579H124.608ZM146.236 26.6369V19.7842H149.954V16.0263H146.236V8.87895H142.146V16.0263H140.324V19.7842H142.146V26.6369C142.146 32.2368 142.741 35.6263 151.107 34.7421L149.88 31.279C146.533 31.6842 146.236 30.7632 146.236 26.6369ZM157.402 26.6369V19.7842H161.121V16.0263H157.402V8.87895H153.312V16.0263H151.49V19.7842H153.312V26.6369C153.312 32.2368 153.907 35.6263 162.273 34.7421L161.046 31.279C157.7 31.6842 157.402 30.7632 157.402 26.6369ZM180.579 30.7263L177.455 28.9947C176.303 30.5421 174.481 31.3158 172.213 31.279C169.498 31.2421 167.342 29.5474 166.747 26.8579H180.839C181.471 19.1947 177.158 15.6947 171.952 15.6211C166.412 15.5474 162.657 19.6368 162.657 25.3474C162.657 30.9474 166.598 35 172.213 35.0368C176.005 35.0737 178.868 33.5263 180.579 30.7263ZM166.858 23.3579C167.49 20.8895 169.387 19.3053 171.952 19.3053C174.332 19.3053 176.414 20.8895 177.121 23.3579H166.858ZM182.574 34.6316H186.664V26.8947C186.664 22.6211 188.672 20.0053 190.94 19.7474C193.023 19.5263 194.324 20.2263 194.807 20.5947L196.778 17.6474C195.7 16.6526 194.25 15.7684 191.572 15.8421C189.49 15.879 187.854 17.0947 186.664 18.7526V16.0263H182.574V34.6316ZM193.619 34.6316H198.23L200.982 27.3368C204.588 27.079 207.228 27.4474 209.534 28.7C213.438 30.8368 214.776 33.1579 215.855 34.7421H218.271L208.232 8.84211H203.622L193.619 34.6316ZM202.655 22.9895L205.927 14.4053L209.794 24.5737C208.046 23.6526 206.15 22.9526 202.655 22.9895ZM220.025 8.80527L220.396 20.0053L220.434 22.7684L220.285 34.6316H224.747V31.1684C224.747 25.4579 224.635 19.0105 223.185 12.7842L222.442 8.80527H220.025Z" fill="#073B5D"/></g></svg>\n',
                skipped: false,
                nextLevel: 'NetworkAI',
                link: 'cover-letters.index',
                progress: 0,
                completed: false,
                items: [
                    {
                        name: "watchCoverLetterTutorial",
                        description: "Watch <a class='text-won-green hover:underline font-bold'>CoverletterAI Tutorial</a>",
                        info: 'Watch the full tutorial of how you can use CoverLetterAI to make the perfect cover letter to supplement your applications!',
                        completed: false,
                        showInfo: false,
                        link: 'https://www.youtube.com/watch?v=caQ2vTGYoiI&t=15s',
                        showLink: true,
                        checkSubscription: false,
                    }, {
                        name: "generateFirstCoverLetter",
                        description: "Generate first cover letter",
                        completed: false,
                        showInfo: false,
                        checkSubscription: false,
                        info: 'In CoverLetterAI, select a resume from WonsultingAI, target role and target company to generate your first cover letter!'
                    }, {
                        name: "downloadCoverLetter",
                        description: "Download cover letter",
                        completed: false,
                        showInfo: false,
                        checkSubscription: false,
                        info: 'Once you’ve finished your cover letter, select the “Download” button at the top right of CoverLetterAI. You can download in either PDF or Word format.'
                    }]
            },
            {
                level: 3,
                title: "NetworkAI",
                description: "The easiest way to network!",
                link: 'networking-tool',
                nextLevel: 'JobTrackerAI',
                icon: '<svg width="179" height="42" viewBox="0 0 179 42" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_4913_7929" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="179" height="42"><path d="M179 0H0V42H179V0Z" fill="white"/></mask><g mask="url(#mask0_4913_7929)"><path d="M19.2053 34.6315H23.6057V8.84203L19.1307 8.87888C19.1307 14.0368 19.1307 20.1894 20.1749 28.8473L6.93635 8.84203L1.82739 8.80519V34.6315H4.4751C5.78031 27.4841 6.11593 21.2578 6.22781 15.4368L19.2053 34.6315ZM44.6819 30.7262L41.5494 28.9947C40.3933 30.542 38.566 31.3157 36.2912 31.2789C33.5689 31.242 31.406 29.5473 30.8094 26.8578H44.9429C45.5769 19.1947 41.251 15.6947 36.0302 15.621C30.4737 15.5473 26.7073 19.6368 26.7073 25.3473C26.7073 30.9473 30.6602 34.9999 36.2912 35.0368C40.095 35.0736 42.9664 33.5262 44.6819 30.7262ZM30.9212 23.3578C31.5552 20.8894 33.4571 19.3052 36.0302 19.3052C38.4169 19.3052 40.5052 20.8894 41.2137 23.3578H30.9212ZM52.6125 26.6368V19.7841H56.3417V16.0262H52.6125V8.87888H48.5104V16.0262H46.6831V19.7841H48.5104V26.6368C48.5104 32.2368 49.1071 35.6262 57.4977 34.742L56.2671 31.2789C52.9108 31.6841 52.6125 30.7631 52.6125 26.6368ZM63.8306 34.6315H68.231L72.3704 22.3262L76.6216 34.6315H80.9847L86.5412 16.0262H82.0289L78.5608 29.621L74.4214 16.2473L74.4587 16.1736H70.282L66.2172 29.621L62.6372 16.0262H58.0877L63.8306 34.6315ZM96.5057 35.0368C102.099 35.0368 106.052 31.021 106.052 25.3473C106.052 19.6368 102.099 15.621 96.5057 15.621C90.8747 15.621 86.9218 19.6368 86.9218 25.3473C86.9218 31.021 90.8747 35.0368 96.5057 35.0368ZM91.0238 25.3473C91.0238 21.8473 93.2986 19.3789 96.5057 19.3789C99.7128 19.3789 101.95 21.8473 101.95 25.3473C101.95 28.8105 99.7128 31.2789 96.5057 31.2789C93.2986 31.2789 91.0238 28.8105 91.0238 25.3473ZM107.739 34.6315H111.842V26.8947C111.842 22.621 113.855 20.0052 116.13 19.7473C118.218 19.5262 119.524 20.2262 120.008 20.5947L121.985 17.6473C120.903 16.6526 119.449 15.7683 116.764 15.842C114.676 15.8789 113.035 17.0947 111.842 18.7526V16.0262H107.739V34.6315ZM123.667 34.6315H127.769V28.9578L130.454 26.342L136.831 34.6315H141.642L133.288 23.5789L140.97 16.0262H135.787L127.769 23.8368V7.66309H123.667V34.6315ZM142.397 34.6315H147.022L149.781 27.3368C153.398 27.0789 156.046 27.4473 158.358 28.6999C162.274 30.8368 163.616 33.1578 164.698 34.742H167.122L157.053 8.84203H152.429L142.397 34.6315ZM151.459 22.9894L154.741 14.4052L158.619 24.5736C156.867 23.6526 154.965 22.9526 151.459 22.9894ZM168.88 8.80519L169.253 20.0052L169.29 22.7683L169.141 34.6315H173.616V31.1683C173.616 25.4578 173.504 19.0105 172.05 12.7841L171.304 8.80519H168.88Z" fill="#073B5D"/></g></svg>',
                skipped: false,
                progress: 0,
                showInfo: false,
                completed: false,
                items: [
                    {
                        name: "watchNetworkAITutorial",
                        description: "Watch <a class='text-won-green hover:underline font-bold'>NetworkAI Tutorial</a>",
                        completed: false,
                        link:'https://www.youtube.com/watch?v=yvXO7Wa0Lps&t=10s',
                        showInfo: false,
                        showLink: true,
                        checkSubscription: false,
                        info: 'Watch the full tutorial of how you can use NetworkAI identify professionals to reach out to and create LinkedIn personalized invites!'
                    }, {
                        name: "generateFirstNetworkAI",
                        description: "Generate your first LinkedIn personalized invite",
                        completed: false,
                        showInfo: false,
                        checkSubscription: false,
                        info: 'Go to our Networking Tool and select one of the options: I want an interview, I want industry connections, I’m just expanding my network, or I want to send a follow up message. Then add your information and click generate!'
                    },
                    {
                        name: "addFavoriteNetworkAI",
                        description: "Save your favorite LinkedIn personalized invite",
                        completed: false,
                        showInfo: false,
                        checkSubscription: false,
                        info: 'After generating your message, select the “❤” to save to your favorites'
                    }, {
                        name: "navigateToLinkedIn",
                        description: "Navigate to LinkedIn to network with a recruiter or professional",
                        completed: false,
                        showInfo: false,
                        checkSubscription: false,
                        info: 'After you’ve crafted your message, select the “Go to LinkedIn” button to find professionals to connect with!'
                    }]
            },
            {
                level: 4,
                title: "JobTrackerAI",
                nextLevel: 'InterviewAI',
                description: "Automatically track your job applications with AI.",
                link: 'job-tracker',
                icon: '<svg width="215" height="28" viewBox="0 0 215 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.56669 21.3545C5.50229 22.9598 6.84955 23.8932 8.53362 23.8932C11.041 23.8932 13.3613 22.2505 13.4736 17.6585C13.8104 12.1705 14.3717 5.71182 15.3822 1.30648L17.8147 1.26915L17.665 17.8078C17.5528 24.6398 13.511 27.9252 8.53362 27.9252C4.22988 27.9252 1.12369 25.4985 0.000976562 21.3545H4.56669ZM29.5264 27.8505C23.8754 27.8505 19.9085 23.7812 19.9085 18.0318C19.9085 12.2452 23.8754 8.17582 29.5264 8.17582C35.14 8.17582 39.1069 12.2452 39.1069 18.0318C39.1069 23.7812 35.14 27.8505 29.5264 27.8505ZM24.0251 18.0318C24.0251 21.5412 26.308 24.0425 29.5264 24.0425C32.7449 24.0425 34.9903 21.5412 34.9903 18.0318C34.9903 14.4852 32.7449 11.9838 29.5264 11.9838C26.308 11.9838 24.0251 14.4852 24.0251 18.0318ZM51.6903 27.8505C49.2578 27.8505 47.3866 26.8798 46.0019 25.4238V27.4398H41.9227V0.111816H46.0019V10.6025C47.3866 9.14648 49.2578 8.17582 51.6903 8.17582C56.9297 8.17582 60.8966 12.2452 60.8966 18.0318C60.8966 23.7812 56.9297 27.8505 51.6903 27.8505ZM45.8148 18.0318C45.8148 21.5412 48.0976 24.0425 51.3161 24.0425C54.5345 24.0425 56.78 21.5412 56.78 18.0318C56.78 14.4852 54.5345 11.9838 51.3161 11.9838C48.0976 11.9838 45.8148 14.4852 45.8148 18.0318ZM57.3615 5.33849V1.30648L79.2919 1.34382V3.06115C73.4538 3.88249 69.674 7.05582 69.0752 12.8798C68.8881 14.7838 68.8507 17.1732 68.8507 18.1812V20.4212V27.4398H64.5469V20.4212C64.6218 12.6185 65.1083 8.06382 67.5034 5.33849H57.3615ZM79.6871 27.4398V8.58648H83.8037V11.3492C85.0013 9.66915 86.648 8.43715 88.7437 8.39982C91.4382 8.32515 92.8977 9.22115 93.983 10.2292L91.9996 13.2158C91.5131 12.8425 90.2032 12.1332 88.1075 12.3572C85.8246 12.6185 83.8037 15.2692 83.8037 19.5998V27.4398H79.6871ZM112.27 27.4398H108.453L108.415 25.2372C106.619 26.9545 104.037 27.8505 101.23 27.8505C99.9948 27.8505 95.6911 27.4398 95.0548 23.7065C93.9321 17.2852 99.6954 15.2692 108.153 15.7545L108.116 15.2692C107.517 12.6558 106.207 12.0212 103.812 12.0212C101.903 12.0212 99.8451 12.8052 98.7598 14.4852L95.691 12.5065C97.188 9.70648 99.9199 8.21315 103.775 8.21315C109.201 8.21315 112.27 10.8638 112.27 18.0318V27.4398ZM99.0592 22.6612C99.4334 24.5652 102.278 24.3038 103.737 23.9678C105.197 23.6318 107.891 22.3625 108.228 19.1518C103.288 18.7038 98.4604 19.5625 99.0592 22.6612ZM129.844 14.5972C128.721 12.8425 126.775 11.9838 124.866 11.9838C121.648 11.9838 119.365 14.4852 119.365 18.0318C119.365 21.5412 121.648 24.0425 124.866 24.0425C126.85 24.0425 128.796 23.0718 129.956 21.3545L133.025 23.2212C131.528 26.0585 128.384 27.8505 124.866 27.8505C119.215 27.8505 115.249 23.7812 115.249 18.0318C115.249 12.2452 119.215 8.21315 124.866 8.21315C128.272 8.21315 131.341 10.0052 132.838 12.8052L129.844 14.5972ZM134.887 27.4398V0.111816H139.004V16.5012L147.05 8.58648H152.252L144.543 16.2398L152.926 27.4398H148.098L141.698 19.0398L139.004 21.6905V27.4398H134.887ZM170.42 23.4825C168.698 26.3198 165.817 27.8878 161.999 27.8505C156.348 27.8132 152.381 23.7065 152.381 18.0318C152.381 12.2452 156.161 8.10115 161.737 8.17582C166.977 8.25048 171.318 11.7972 170.682 19.5625H156.498C157.097 22.2878 159.267 24.0052 161.999 24.0425C164.282 24.0798 166.116 23.2958 167.276 21.7278L170.42 23.4825ZM156.61 16.0158H166.939C166.228 13.5145 164.133 11.9092 161.737 11.9092C159.155 11.9092 157.247 13.5145 156.61 16.0158ZM172.428 27.4398V8.58648H176.545V11.3492C177.742 9.66915 179.389 8.43715 181.485 8.39982C184.179 8.32515 185.639 9.22115 186.724 10.2292L184.741 13.2158C184.254 12.8425 182.944 12.1332 180.848 12.3572C178.566 12.6185 176.545 15.2692 176.545 19.5998V27.4398H172.428ZM183.544 27.4398L193.61 1.30648H198.251L208.355 27.5518H205.923C204.838 25.9465 203.49 23.5945 199.561 21.4292C197.24 20.1598 194.583 19.7865 190.953 20.0478L188.184 27.4398H183.544ZM192.637 15.6425C196.155 15.6052 198.064 16.3145 199.823 17.2478L195.931 6.94382L192.637 15.6425ZM210.12 1.26915H212.552L213.301 5.30115C214.76 11.6105 214.873 18.1438 214.873 23.9305V27.4398H210.382L210.532 15.4185L210.494 12.6185L210.12 1.26915Z" fill="#073B5D"/></svg>',
                skipped: false,
                completed: false,
                progress: 0,
                items: [{
                    name: "syncJobTracker",
                    description: "Sync your email to track your applied jobs",
                    checkSubscription: false,
                    completed: false
                }]
            },
            {
                level: 5,
                title: "InterviewAI",
                description: "Improve your interview skills with our personalized virtual interviews.",
                skipped: false,
                completed: false,
                link: 'interview-ai',
                icon: '<svg width="190" height="29" viewBox="0 0 190 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.664307 0.645163H3.17421L3.94648 4.80807C5.45243 11.3223 5.56827 18.0677 5.56827 24.0423V27.6655H0.934604L1.08906 15.2539L1.05045 12.363L0.664307 0.645163ZM8.86402 27.6655V8.20007H13.1115V10.6284C14.6175 8.93243 16.7412 7.77607 19.5602 7.77607C26.0087 7.77607 27.2829 11.9775 27.3215 18.3375V27.6655H23.074V17.9521C23.074 14.907 22.1859 11.7077 18.9037 11.7077C15.5056 11.7077 13.1115 14.0204 13.1115 17.6823V27.6655H8.86402ZM35.9803 19.3012C35.9803 23.6183 36.2892 24.5819 39.7645 24.1579L41.0387 27.7812C32.3506 28.7063 31.7328 25.1601 31.7328 19.3012V12.1317H29.8407V8.20007H31.7328V0.722253H35.9803V8.20007H39.8417V12.1317H35.9803V19.3012ZM60.0487 23.5797C58.2725 26.5092 55.2992 28.1281 51.3606 28.0895C45.5299 28.051 41.4368 23.811 41.4368 17.9521C41.4368 11.9775 45.3368 7.69898 51.0903 7.77607C56.4962 7.85316 60.9755 11.515 60.319 19.5324H45.6844C46.3022 22.3463 48.5418 24.1193 51.3606 24.1579C53.716 24.1964 55.6081 23.387 56.8052 21.7681L60.0487 23.5797ZM45.8002 15.8706H56.4576C55.724 13.2881 53.5616 11.6306 51.0903 11.6306C48.4259 11.6306 46.4566 13.2881 45.8002 15.8706ZM62.1209 27.6655V8.20007H66.3685V11.0524C67.6041 9.31789 69.3031 8.04589 71.4655 8.00734C74.2457 7.93025 75.7516 8.85534 76.8714 9.89607L74.8249 12.9797C74.3229 12.5943 72.9714 11.8619 70.8091 12.0932C68.4536 12.363 66.3685 15.0997 66.3685 19.571V27.6655H62.1209ZM85.0823 27.6655L77.4367 8.20007H82.109L87.3219 22.7317L92.4961 8.20007H97.1684L89.6773 27.6655H85.0823ZM99.9789 27.6655V8.20007H104.226V27.6655H99.9789ZM99.67 2.53389C99.67 1.26189 100.713 0.182617 102.103 0.182617C103.454 0.182617 104.497 1.26189 104.497 2.53389C104.497 3.92153 103.454 4.96225 102.103 4.96225C100.713 4.96225 99.67 3.92153 99.67 2.53389ZM125.816 23.5797C124.04 26.5092 121.067 28.1281 117.128 28.0895C111.297 28.051 107.204 23.811 107.204 17.9521C107.204 11.9775 111.104 7.69898 116.858 7.77607C122.264 7.85316 126.743 11.515 126.086 19.5324H111.452C112.07 22.3463 114.309 24.1193 117.128 24.1579C119.483 24.1964 121.375 23.387 122.572 21.7681L125.816 23.5797ZM111.568 15.8706H122.225C121.491 13.2881 119.329 11.6306 116.858 11.6306C114.193 11.6306 112.224 13.2881 111.568 15.8706ZM133.256 27.6655L127.309 8.20007H132.02L135.727 22.4233L139.936 8.35425H144.261L144.222 8.43134L148.508 22.4233L152.099 8.20007H156.771L151.018 27.6655H146.5L142.098 14.7913L137.812 27.6655H133.256ZM157.533 27.6655L167.921 0.683708H172.709L183.134 27.7812H180.625C179.505 26.1237 178.115 23.6953 174.06 21.4597C171.666 20.1492 168.925 19.7637 165.179 20.0335L162.322 27.6655H157.533ZM166.917 15.4852C170.546 15.4466 172.516 16.179 174.331 17.1426L170.315 6.50407L166.917 15.4852ZM184.955 0.645163H187.465L188.237 4.80807C189.743 11.3223 189.859 18.0677 189.859 24.0423V27.6655H185.225L185.38 15.2539L185.341 12.363L184.955 0.645163Z" fill="#073B5D"/></svg>',
                progress: 0,
                items: [
                    {
                        name: "watchInterviewAITutorial",
                        showLink: true,
                        description: "Watch <a class='text-won-green hover:underline font-bold' target='_blank'>InterviewAI Tutorial</a>",
                        info: 'Watch the full tutorial of how you can use InterviewAI to practice for your next interview!',
                        link: 'https://www.youtube.com/watch?v=s7WokLdlrpI',
                        showInfo: false,
                        checkSubscription: false,
                        completed: false,
                    },
                    {
                        name: "startInterview",
                        description: "Start an interview by entering the job description or selecting a recent job application.",
                        completed: false,
                        checkSubscription: false,
                    },
                    {
                        name: "completeInterview",
                        description: "Complete the interview by answering all questions.",
                        checkSubscription: false,
                        completed: false
                    },
                    {
                        name: "reviewInterviewScore",
                        description: "Review the interview score and the report generated.",
                        checkSubscription: false,
                        completed: false
                    },
                ]
            },
        ]);
    const currentLevelIndex = ref(0);
    const originalCurrentIndex = ref(1);
    const showOnboardingChecklist = ref(false)
    const userChecklistLevels = ref([])
    
    watch(isSubscribe, (newSubscriptionStatus) => {
        if(!isAuthenticated()) return;
        updateAllProgress(newSubscriptionStatus);
    });
    
     const initializeLevels = (user) => {
         if(!isAuthenticated()) return;

        userChecklistLevels.value = user?.onboarding_checklist?.levels;
        if (userChecklistLevels.value) {
              userChecklistLevels.value.forEach((userLevel) => {
                const checklistLevel = checklistLevels.value.find(level => level.level === userLevel.level);
                if (checklistLevel) {
                    checklistLevel.completed = userLevel.completed;
                    checklistLevel.skipped = userLevel.skipped;
                    checklistLevel.progress = userLevel.progress;
                    checklistLevel.items.forEach((item, index) => {
                        item.completed = userLevel?.items[index]?.completed;
                    });
                }
            });
        } else {
            resetChecklist()
        }
    };
  
    const setOnboardingChecklist = (data) => {
        const currentLevel = data?.onboarding_checklist?.current_level ?? 0;
        setCurrentLevel(currentLevel);
        initializeLevels(data);
    
        if (!data?.onboarding_checklist) {
            getOriginalCurrentLevel();
        }
    }
    
    const currentLevel = computed(() => checklistLevels.value[currentLevelIndex.value]);
    const originalCurrentLevel = computed(() => checklistLevels.value[originalCurrentIndex.value]);
 
    const goToNextLevel = async () => {
        if (currentLevelIndex.value < checklistLevels.value.length - 1) {
            closeToggleInfo(currentLevelIndex.value)
            currentLevelIndex.value++;
        }
    };
    
    const getOriginalCurrentLevel = () => {
        for (let index = 0; index < checklistLevels.value.length; index++) {
            const level = checklistLevels.value[index];
            if (!level.completed && !level.skipped) {
                currentLevelIndex.value = index;
                if(index !== 0 || index !== checklistLevels.value.length - 1) {
                    originalCurrentIndex.value = index;
                }
                break;
            } else {
                originalCurrentIndex.value = checklistLevels.value.length - 1;
            }
        }
    }

    const toggleInfo = (itemIndex) => {
        const item = checklistLevels.value[currentLevelIndex.value].items[itemIndex];
        item.showInfo = !item.showInfo;
    };

    const closeToggleInfo = (currentLevel) => {
        checklistLevels.value[currentLevel].items.forEach(item => item.showInfo = false)
    };

    const setCurrentLevel = (level) => {
        currentLevelIndex.value = level
    }

    const goToPreviousLevel = async () => {
        if (currentLevelIndex.value > 0) {
            currentLevelIndex.value--;
        }
    };
    
    const updateAllProgress = (isSubscribed) => {
        checklistLevels.value.forEach((_, index) => updateProgress(index, isSubscribed));
        getOriginalCurrentLevel()
    };

    const skipLevel = () => {
        const level = checklistLevels.value[currentLevelIndex.value];
        level.skipped = true;
        goToNextLevel();
    };

    const updateProgress = (levelIndex, isSubscribed) => {
        const level = checklistLevels.value[levelIndex];
        
        // Calculate total items based on subscription status
        const totalItems = isSubscribed ? level.items.length : level.items.filter(item => !item.checkSubscription).length;
    
        if (totalItems === 0) {
            level.progress = 0;
            level.completed = false;
            return;
        }
        
        // Calculate completed items based on subscription status
        const completedItems = isSubscribed 
            ? level.items.filter(item => item.completed).length 
            : level.items.filter(item => item.completed && !item.checkSubscription).length;
        
        level.progress = Math.floor((completedItems / totalItems) * 100);
        
        // Set the completed status based on progress and item completion
        if (level.progress === 100) {
            level.completed = true;
            getOriginalCurrentLevel();
        } else {
            level.completed = false;
        }
    };

    const filterChecklistLevels = (levels) => {
        return levels.map(level => ({
            level: level.level,
            completed: level.completed,
            skipped: level.skipped,
            progress: level.progress,
            items: level.items.map(item => ({
                completed: item.completed
            }))
        }));
    };

    const saveProgress = async () => {
        if(!isAuthenticated()) return;

        updateProgress(currentLevelIndex.value, isSubscribe)
        const filteredLevels = filterChecklistLevels(checklistLevels.value);

        const response = await update({
            options: {
                onboarding_checklist_passed: true,
            },
            onboarding_checklist: {
                levels: filteredLevels,
                current_level: currentLevelIndex.value,
            }
        });
        setUser(response.data.data)
    };

    const handleShowOnboardingChecklist = () => {
        showOnboardingChecklist.value = true
    }

    const handleCloseOnboardingChecklist = () => {
        if(!getUser()?.options?.onboarding_checklist_passed) {
            saveProgress()
        }
        
        showOnboardingChecklist.value = false
    }

    const resetChecklist = () => {
         checklistLevels.value.forEach(level => {
              level.skipped = false;
              level.completed = false;
              level.progress = 0;
              level.items.forEach(item => {
                item.completed = false;
              });
        });
    }

    const markItemAsCompleted = (levelIndex, itemName) => {
        const item = checklistLevels.value[levelIndex].items.find(item => item.name === itemName);
        if(item.completed) {
            return;
        }
        
        item.completed = true;
        
        updateProgress(levelIndex, isSubscribe.value);
        saveProgress()
    };


    return {
        initializeLevels,
        checklistLevels,
        currentLevelIndex,
        showOnboardingChecklist,
        currentLevel,
        originalCurrentLevel,
        originalCurrentIndex,
        getOriginalCurrentLevel,
        toggleInfo,
        goToNextLevel,
        goToPreviousLevel,
        skipLevel,
        updateProgress,
        saveProgress,
        setCurrentLevel,
        handleShowOnboardingChecklist,
        handleCloseOnboardingChecklist,
        updateAllProgress,
        setOnboardingChecklist,
        markItemAsCompleted,
    };
});
